export default __webpack_public_path__ + "540422ebb7f3f1f3a8fa00a9fa06e2ac.png";